import { render } from "./ServerItem.vue?vue&type=template&id=6d801e94"
import script from "./ServerItem.vue?vue&type=script&lang=js"
export * from "./ServerItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/alisa/dev/projects/la2dream/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__